// slice utility functions


export const handleResponseStatus = (payload, actionType = 'status') => {
    // Default values for the response state
    let responseState = {
        [`${actionType}`]: 'failed', // Dynamic key based on actionType
        error: 'An unexpected error occurred', // Default error message
    };
    // Check payload status
    if (payload.status === 200) {
        responseState[`${actionType}`] = 'success';
        responseState.error = null;
    } else if (payload.status === 201) {
        responseState[`${actionType}`] = 'success';
        responseState.error = null;
    }  else if (payload.status === 400) {
        responseState[`${actionType}`] = 'failed';
        responseState.error = payload.data.message || 'Unknown error';
    } else if (payload.status === 401) {
        responseState[`${actionType}`] = 'failed';
        responseState.error = payload.data.message || 'Unknown error';
    } else {
        responseState[`${actionType}`] = 'failed';
        responseState.error = payload.data.message || responseState.error;
    }
    return responseState;
};

export const updateIdField = (items) => {
    return items.map(item => ({
        ...item,
        id: item._id
    }));
}

export const updateItem = (updatedItem, items) => {
    const normalizedItem = { ...updatedItem, id: updatedItem._id }; // Ensure id is set
    const index = items.findIndex(item => item._id === updatedItem._id);
    if (index !== -1) {
        // Update existing item
        items[index] = { ...items[index], ...normalizedItem };
    } else {
        // Add new item if not found
        items.push(normalizedItem);
    }
    return items;
};

export const sortByName = (data) => {
    return Object.fromEntries(
        Object.entries(data)
            .sort((a, b) => a[1].localeCompare(b[1]))
    );
};



